import Notification20 from '@carbon/icons-react/es/notification/20';
import React, { useCallback, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CompactMenuTitle } from 'components/atoms/menu/compact-menu';
import { DrawerContent } from 'components/organisms/task-pane/task-detail';
import { RoutePaths } from 'constant';
import { useNotificationsDrawerContext } from 'contexts/providers/notifications-drawer';
import { usePending } from 'stores/notifications';
import { handleLastSeenAtSubscription } from 'stores/notifications/use-pending';
import { List } from '../list';
import { useNotificationsDrawer } from './hash-based-notifications';
import { Drawer } from './styled';

const StyledTitle = styled.span`
  font-size: var(--heading-5-size);
`;

export const NotificationsDrawer = () => {
  const [params, , hide] = useNotificationsDrawer();
  const { visibility, setVisibility } = useNotificationsDrawerContext();

  const [pending, resetPending] = usePending();
  const refreshRef = useRef<() => void>();
  const listRef = useCallback((instance) => {
    if (instance?.refresh != null) {
      refreshRef.current = instance.refresh;
    }
  }, []);

  useEffect(() => {
    handleLastSeenAtSubscription();

    return () => {
      handleLastSeenAtSubscription().unsubscribe();
    };
  }, []);

  const onClose = useCallback(() => {
    setVisibility(false);
    setTimeout(hide, 100);
  }, [hide, setVisibility]);

  useEffect(() => {
    switch (params[0]) {
      case 'show':
        setVisibility(true);
        if (pending > 0) {
          resetPending();
        }
        break;

      case 'invalid':
      default:
        setVisibility(false);
    }
  }, [params, pending, resetPending, setVisibility]);

  return (
    <Drawer
      onClose={onClose}
      destroyOnClose
      visible={visibility}
      title={
        <CompactMenuTitle
          icon={<Notification20 />}
          text={
            <StyledTitle>
              <FormattedMessage id="notifications" />
            </StyledTitle>
          }
        />
      }
    >
      <DrawerContent.Content>
        <List
          ref={listRef}
          pending={pending}
          configScreenUrl={RoutePaths.notificationsSettings}
          resetPending={resetPending}
        />
      </DrawerContent.Content>
    </Drawer>
  );
};
